/**
 * @generated SignedSource<<b272639b8602c5e4bc4880f720c484c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteWebhookSubscriptionInput = {
  id: any;
};
export type OpsgenieIntegrationDeleteWebhookSubscriptionMutation$variables = {
  input: DeleteWebhookSubscriptionInput;
};
export type OpsgenieIntegrationDeleteWebhookSubscriptionMutation$data = {
  readonly deleteWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type OpsgenieIntegrationDeleteWebhookSubscriptionMutation = {
  response: OpsgenieIntegrationDeleteWebhookSubscriptionMutation$data;
  variables: OpsgenieIntegrationDeleteWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "deleteWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsgenieIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsgenieIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3312207ba1576650299e73da7b2b5c6a",
    "id": null,
    "metadata": {},
    "name": "OpsgenieIntegrationDeleteWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation OpsgenieIntegrationDeleteWebhookSubscriptionMutation(\n  $input: DeleteWebhookSubscriptionInput!\n) {\n  deleteWebhookSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2eda04fa40da888b80657be7d0b2624";

export default node;
